<template>
  <div v-if="(jwtAccessValid() && userProfile.checked && isReciever) || isAdmin || isManager || isManagerFB">
    <transfers-card :write-off="JSON.parse(writeOff)" v-if="isMobile" />
    <transfers-table :write-off="JSON.parse(writeOff)" v-else />
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from "@/components/commonMixin.js";
import TransfersCard from "./TransfersCard.vue";
import TransfersTable from "./TransfersTable.vue";

export default {
  name: "Transfers",
  components: { TransfersCard, TransfersTable },
  props: {
    writeOff: { default: false }
  },
  setup(props) {
    useCommonMixin();
    const {
      jwtAccessValid,
      asyncForEach,
      isReciever,
      userProfile,
      isAdmin,
      isManager,
      isMobile,
      isManagerFB,
    } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const docs = ref([]);
    const profiles = ref([{}]);

    const init = async () => {
      let response = await store.dispatch("FETCHtransfer");
      docs.value = response.status ? response.data : [];
    };

    onMounted(init);

    return {
      jwtAccessValid,
      isReciever,
      docs,
      profiles,
      router,
      userProfile,
      isAdmin,
      isManager,
      isMobile,
      isManagerFB,
    };
  }
};
</script>

<style>
.canceled {
  background-color: #e44d4d6b !important;
}
</style>
